__turbopack_context__.v({
  "article": "article-module-scss-module__kOYvda__article",
  "byline-col": "article-module-scss-module__kOYvda__byline-col",
  "byline-row": "article-module-scss-module__kOYvda__byline-row",
  "footer-share-row": "article-module-scss-module__kOYvda__footer-share-row",
  "heading": "article-module-scss-module__kOYvda__heading",
  "share-col": "article-module-scss-module__kOYvda__share-col",
  "skeleton": "article-module-scss-module__kOYvda__skeleton",
});
